import { cosemApi } from '@services/providers/cosem';
import { ApiPaginationResponse, ApiResponse } from '@services/providers/cosem.types';
import { ActiveFilter } from '@utils/filters';
import { News, NewsTable, NewsToCreate, NewsToUpdate } from './news.types';
import { CdnFile } from '@services/core/cdn/file/file';

const newsApi = cosemApi.injectEndpoints({
    endpoints: (build) => ({
        getAllNews: build.mutation<
            ApiPaginationResponse<NewsTable>,
            { limit?: number; page?: number; search?: string; orderBy?: string; filters?: ActiveFilter[] }
        >({
            query: ({ limit = 10, page = 1, search, orderBy, filters }) => {
                return {
                    url: `/product/news`,
                    method: 'GET',
                    params: { limit, page, search: search ?? '', orderBy: orderBy ?? '', filters: JSON.stringify(filters ?? []) }
                };
            },
            transformResponse: (response: ApiPaginationResponse<NewsTable>) => response
        }),
        getNews: build.mutation<ApiResponse<News>, { id: number }>({
            query: ({ id }) => ({
                url: `/product/news/${id}`,
                method: 'GET'
            }),
            transformResponse: (response: ApiResponse<News>) => response
        }),
        createNews: build.mutation<ApiResponse<News>, NewsToCreate>({
            query: (news) => ({
                url: `/product/news`,
                method: 'POST',
                body: news
            }),
            transformResponse: (response: ApiResponse<News>) => response
        }),
        updateNews: build.mutation<ApiResponse<News>, { id: number; news: NewsToUpdate }>({
            query: ({ id, news }) => ({
                url: `/product/news/${id}`,
                method: 'PUT',
                body: news
            }),
            transformResponse: (response: ApiResponse<News>) => response
        }),
        deleteNews: build.mutation<ApiResponse<News>, { id: number }>({
            query: ({ id }) => ({
                url: `/product/news/${id}`,
                method: 'DELETE'
            }),
            transformResponse: (response: ApiResponse<News>) => response
        }),
        /* Documents */
        getNewsDocuments: build.mutation<ApiResponse<CdnFile[]>, { id: string }>({
            query: ({ id }) => {
                return {
                    url: `/product/news/${id}/documents`,
                    method: 'GET'
                };
            },
            transformResponse: (response: ApiResponse<CdnFile[]>) => response
        }),

        deleteNewsDocument: build.mutation<ApiResponse<void>, { id: string; documentId: string }>({
            query: ({ id, documentId }) => {
                return {
                    url: `/product/news/${id}/document/${documentId}`,
                    method: 'DELETE'
                };
            },
            transformResponse: (response: ApiResponse<void>) => response
        }),
        postNewsDocument: build.mutation<ApiResponse<CdnFile>, { id: string; file: CdnFile }>({
            query: ({ id, file }) => {
                return {
                    url: `/product/news/${id}/document`,
                    method: 'POST',
                    body: file
                };
            },
            transformResponse: (response: ApiResponse<CdnFile>) => response
        })
    })
});

export const {
    useGetAllNewsMutation,
    useCreateNewsMutation,
    useUpdateNewsMutation,
    useGetNewsMutation,
    useDeleteNewsMutation,
    useGetNewsDocumentsMutation,
    useDeleteNewsDocumentMutation,
    usePostNewsDocumentMutation
} = newsApi;
